<template>
	<div>
		<gmap-map
			:center="currentPlace"
			:zoom="localZoom"
			style="width:100%;height: 400px;"
			@center_changer="$emit('on-center-changed', $event)"
		>
			<gmap-marker
				v-for="(m, index) in markers"
				:key="index"
				:clickable="true"
				:position="m.position"
				@click="selectedMarker(m)"
			></gmap-marker>
		</gmap-map>
	</div>
</template>

<script>
function mounted() {
	this.localZoom = this.zoom;
	this.currentPlace = this.location;
	this.geolocate();
	if (this.allMarkers.length > 0) {
		this.setAllMarkers();
	}
}

function geolocate() {
	this.markers.push({ position: this.location });
}

function setAllMarkers() {
	const onlyLat = [];
	const onlyLng = [];
	this.allMarkers.forEach((m) => {
		if (m.location) {
			const { id, name } = m;
			const { x: lat, y: lng } = m.location;
			this.markers.push({ position: { lat, lng, id, name } });
			onlyLat.push(lat);
			onlyLng.push(lng);
		}
	});
	const averageLat = onlyLat.reduce((acc, it) => acc + it, 0) / onlyLat.length;
	const averageLng = onlyLng.reduce((acc, it) => acc + it, 0) / onlyLng.length;
	this.currentPlace = { lat: averageLat, lng: averageLng };
}

function selectedMarker(selectedMarked) {
	this.$emit('choosed-warehouse', selectedMarked.position);
}

function zoom(newZoom) {
	this.localZoom = newZoom;
}

function locationHandler(newLocation) {
	this.currentPlace = newLocation;
}

function markersHandler(newMarkers) {
	this.markers = newMarkers;
}

function data() {
	return {
		localZoom: this.zoom,
		markers: [],
		places: [],
	};
}

export default {
	name: 'google-map',
	data,
	methods: {
		geolocate,
		locationHandler,
		markersHandler,
		selectedMarker,
		setAllMarkers,
	},
	mounted,
	props: {
		location: {
			default: () => {},
			type: Object,
		},
		allMarkers: {
			default: () => [],
			type: Array,
		},
		zoom: {
			default: 15,
			type: Number,
		},
	},
	watch: {
		location: {
			deep: true,
			handler: locationHandler,
		},
		markers: {
			deep: true,
			handler: markersHandler,
		},
		zoom,
	},
};
</script>


// WEBPACK FOOTER //
// mapComponent.vue?7566df1b